export default __webpack_public_path__ + "static/media/metamask_logo.4990a263.svg";